module.exports = __webpack_public_path__ + "media/MRI18B.80037970.mp3";